export const COINS_INFO_ROUTE = {
  TITLE: 'Coins Info',
  ABSOLUTE_PATH: '/coins-info',
  EXACT_PATH: '/coins-info',
};